import * as PropTypes from 'prop-types';
import { TextAreaRender } from '../TextAreaRender';
import { CellComponentWrapper } from './styles';

TextAreaRender.propTypes = {
  dataTestId: PropTypes.string,
  className: PropTypes.string,
  fieldValue: PropTypes.string,
};

const CellComponent = (props) => {
  const { fieldTypeName, isSelector, isFullWidth, children } = props;

  return (
    <CellComponentWrapper
      data-field-type={fieldTypeName}
      fullWidth={isFullWidth}
      isSelector={isSelector && isFullWidth}
    >
      {children}
    </CellComponentWrapper>
  );
};

CellComponent.propTypes = {
  isSelector: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  children: PropTypes.node,
  fieldTypeName: PropTypes.string,
};

export default CellComponent;
